function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "avatar-san-2x-secret-a",
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#888FC1",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5554A7",
  offset: "52.26%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2C28A7",
  offset: "100%"
})), /*#__PURE__*/React.createElement("rect", {
  id: "avatar-san-2x-secret-b",
  width: 95,
  height: 95,
  rx: 22
}), /*#__PURE__*/React.createElement("path", {
  id: "avatar-san-2x-secret-c",
  d: "M50.374 40.946c1.02 1.232 2.713 3.12 4.888 5.13.43.395.152 1.11-.432 1.11h-5.304c-.55 0-1.083.213-1.47.605-.715.73-2.358 1.957-5.77 2.753-3.794.886-9.18 1.21-11.714 1.316 1.902-.746 3.752-1.63 5.402-2.68 5.392-3.433 8.408-6.538 9.83-8.24.303-.367.757-.576 1.233-.576h2.095c.48 0 .935.213 1.242.583zM88.5 24.114v46.772c0 9.728-7.886 17.614-17.614 17.614H24.114c-5.46 0-10.348-2.5-13.58-6.414-.406-.49-.06-1.23.576-1.23h22.93c10.976 0 21.326.226 30.54-3.925 6.7-3.02 10.482-8.263 12.047-10.9.422-.71-.09-1.61-.916-1.61H67.13c-.57 0-1.103.27-1.456.72-2.21 2.807-8.526 7.3-18.38 7.3H8.054c-.854 0-1.553-.7-1.553-1.553v-46.77C6.5 14.385 14.387 6.5 24.115 6.5h46.772c9.728 0 17.614 7.886 17.614 17.614zM64.338 58.628c.424-.705-.1-1.602-.92-1.602h-9.093c-.536 0-1.05.23-1.392.64-1.835 2.21-4.376 3.682-9.054 3.682H23.212c-.93 0-1.686.755-1.686 1.686v3.51c0 .93.755 1.685 1.686 1.685h20.153c10.172 0 18.207-5.006 20.97-9.603zm16.393-8.586c0-.797-.556-1.484-1.336-1.65-2.513-.533-8.06-1.802-12.198-3.423-2.487-.976-4.325-2.366-5.595-3.6-.38-.367-.117-1.01.41-1.01h16.41c.93 0 1.686-.753 1.686-1.684v-3.453c0-.93-.755-1.686-1.686-1.686H50.954c-.35 0-.6-.34-.494-.672.39-1.244.89-2.9 1.27-4.38.095-.375.43-.635.816-.635h12.44c.687 0 1.322.37 1.664.966l.1.175c.24.42.687.68 1.172.68h6.83c.95 0 1.55-1.016 1.09-1.845l-5.025-9.09c-.305-.55-.884-.892-1.513-.892h-7.32c-.72 0-1.17.776-.812 1.4l1.107 1.935c.264.465-.07 1.044-.608 1.044H37.468c-.605 0-1.013-.615-.777-1.172l2.87-6.784c.243-.57-.175-1.2-.793-1.2h-7.733c-.697 0-1.328.41-1.614 1.045l-3.25 7.23c-.24.537-.773.88-1.36.88h-5.975c-.93 0-1.686.757-1.686 1.688v2.258c0 .93.753 1.686 1.684 1.686h20.79c.585 0 .996.58.796 1.13-.41 1.133-1.06 2.407-1.954 3.744-.338.505-.9.814-1.508.814h-20.74c-.93 0-1.685.755-1.685 1.686v3.453c0 .93.755 1.685 1.686 1.685h13c.514 0 .716.67.284.95-3.578 2.324-8.018 4.312-13.354 5.487-.777.17-1.334.853-1.334 1.65v5.194c0 1.024.904 1.81 1.918 1.67 2.13-.297 5.78-.912 9.67-2.047.547-.16 1.094.246 1.094.815v2.57c0 .74.6 1.34 1.338 1.34h6.453c8.864 0 18.357-2.13 21.697-8.974.252-.516.92-.654 1.373-.3 1.33 1.044 2.767 2.056 4.286 2.96 5.7 3.395 12.82 4.72 16.17 5.183 1.014.14 1.915-.648 1.915-1.67v-5.15z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  fill: "url(#avatar-san-2x-secret-a)",
  xlinkHref: "#avatar-san-2x-secret-b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#avatar-san-2x-secret-c"
}));

var SvgSan = function SvgSan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/san.2953a275.svg";
export { ForwardRef as ReactComponent };